import React from 'react';

import { NPOS_APP } from '../../utils/constants';
import { getApplicationSource } from '../../utils/iframeMessaging';

import RouteValidator from './RouteValidator';

const AuthError = (props) => (
  <RouteValidator routeProps={{ ...props }}>
    <main className="ncss-col-sm-12 ta-sm-c">
      <h1 className="display-3 mt10-sm mb4-sm text-color-error">Authorization Error</h1>
      <p className="body-1">There was an error in validating your access.</p>

      {getApplicationSource() !== NPOS_APP
      && (
      <><p className="body-1 pb3-sm">Please try again by clicking the link below:</p>
        <a
          className="ncss-cta-primary-dark underline text-color-accent pb4-sm"
          href="/"
          rel="noopener noreferrer"
          target="_self"
        >
          Log In to Electronic Journal
        </a>
      </>
      )}
      <p className="body-1 pt4-sm">If this issue continues to occur, please contact Tech Support.</p>
    </main>
  </RouteValidator>
);

export default AuthError;
